import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, NavLink } from 'react-router-dom';
import { Container, Card, CardContent, Typography, Grid, Button, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import { apiHost } from '../../utils/apiHost';

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const baseUrl = apiHost().replace(/^https?:\/\//, '');
  return `${protocol}://${baseUrl}`;
};

export const FormEditProfile = () => {
  const [profile, setProfile] = useState({});
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [nama, setNama] = useState('');
  const [password, setPassword] = useState('');
  const [confPassword, setConfPassword] = useState(''); // State baru untuk konfirmasi password
  const [message, setMessage] = useState('');

  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchProfile = async () => {
      // Pastikan ada user yang terautentikasi sebelum mengambil data
      if (user) {
        try {
          const response = await axios.get(`${getApiBaseUrl()}/me`, { withCredentials: true });
          setProfile(response.data);
          setName(response.data.username);
          setNama(response.data.nama || '');
        } catch (error) {
          setMessage(error.message);
        }
      }
    };

    fetchProfile();
  }, [user]); // Tambahkan `user` sebagai dependensi untuk memuat ulang saat objek user berubah

  const updateProfile = async (e) => {
    e.preventDefault();

    // Pastikan user ada dan memiliki uuid sebelum melakukan pembaruan
    if (!user || !user.uuid) {
      setMessage('User is not logged in or UUID is missing.');
      return;
    }

    // Validasi sederhana untuk password
    if (password !== confPassword) {
      setMessage('Password and confirmation password do not match.');
      return;
    }

    const formData = new FormData();
    formData.append('username', name);
    formData.append('nama', nama || '');
    if (password) {
      formData.append('password', password);
      formData.append('confpassword', confPassword); // Kirim konfirmasi password
    }

    try {
      await axios.put(`${getApiBaseUrl()}/updateuser/me/${user.uuid}`, formData, { // Ganti user.id dengan user.uuid
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true, // Tambahkan withCredentials untuk menjaga sesi
      });

      navigate('/dashboardkaryawan'); // Redirect ke dashboard setelah berhasil
    } catch (error) {
      console.error("Error details:", error.response || error.message);
      setMessage(error.response?.data?.message || 'An error occurred while updating the profile.');
    }
  };

  return (
    <Container maxWidth="sm" style={{ marginTop: '20px' }}>
      <Card>
        <CardContent>
          <form onSubmit={updateProfile}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12}>
                <Typography variant="h5">Update Profile</Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  {profile.username || 'Loading...'}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{ marginTop: '20px' }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Username"
                  variant="outlined"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Nama"
                  variant="outlined"
                  value={nama}
                  onChange={(e) => setNama(e.target.value)}
                  helperText="Ditampilkan di struk & aplikasi, bukan username."
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Password"
                  type="password"
                  variant="outlined"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                  helperText="Kosongkan jika tidak ingin mengubah password."
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Confirm Password"
                  type="password"
                  variant="outlined"
                  value={confPassword}
                  onChange={(e) => setConfPassword(e.target.value)}
                  autoComplete="new-password"
                />
              </Grid>
            </Grid>

            {message && (
              <Typography color="error" variant="body2" style={{ marginTop: '10px' }}>
                {message}
              </Typography>
            )}

            <Grid container spacing={2} style={{ marginTop: '20px' }}>
              <Grid item xs={6}>
                <Button component={NavLink} to="/dashboardkaryawan" variant="contained" color="primary" fullWidth>
                  Kembali
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button type="submit" variant="contained" color="secondary" fullWidth>
                  Update
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Container>
  );
};